import { createCachedSelector, path, defaultKeySelector } from '@cbridge-utils/redux';
import { getRealmFromIssuer } from '../_helpers/getRealmFromIssuer';
import { MASTER_REALM } from '../auth.constant';
import { UserRole } from '../auth.interface';
import { authStoreSelector } from '../auth.selector';

export const userIsManagerSelector = createCachedSelector(
  [
    path(authStoreSelector).apiTokenParsed.realm_access(),
    path(authStoreSelector).apiTokenParsed.iss(),
  ],
  (realmAccess, iss) => {
    const isAdminUI = getRealmFromIssuer(iss) === MASTER_REALM;

    if (!realmAccess && !isAdminUI) {
      return false;
    }
    return realmAccess?.roles?.includes(UserRole.Manager) || isAdminUI;
  },
)({
  keySelector: defaultKeySelector,
});
